<template>
  <p class="arrow">
    <slot />
  </p>
</template>

<style scoped lang="scss">
// FIXME: Atoms粒度ではない気がする
// FIXME: デザインシステム化の際にsvgとして切り出す
$arrow_width: 8px;
$color: var(--color);
$hover: var(--hover);
$between: var(--between);

.arrow {
  align-self: center;
  position: relative;
  padding-right: calc(#{$arrow_width} * 2);
  background-color: transparent;
  line-height: 40px;
  width: max-content;
  transition: all 0.3s linear;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  outline: none;
  cursor: pointer;
  a {
    transition: all 0.5s;
  }

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    right: calc(#{$arrow_width} * 1.5);
    width: $arrow_width;
    height: $arrow_width;
    transition: all 0.1s linear;
    border-top: solid 1px $color;
    border-right: solid 1px $color;
    transform: rotate(45deg) translateY(-50%);
  }

  &:hover::before {
    right: calc(#{$arrow_width} / 1.5);
    border-top: solid 1px $hover;
    border-right: solid 1px $hover;
  }
  &:hover {
    a {
      transition: all 0.5s;
      color: $hover;
    }
  }
  @if ($between) {
    width: 100%;
    &::before {
      right: 1%;
    }
    &:hover::before {
      right: -0.5%;
    }
  }
}
</style>
